export const MAIN_WIDTH = 750;
export const MAIN_HEIGHT = 400;
export const MARGIN = { top: 20, right: 30, bottom: 30, left: 30 };
